import { lazy } from "react"
import {
  ExpeditionRewardsCurrency,
  IExpedition
} from "store/apis/expeditionsAPI/types"

export const EXPEDITION_MODALS = {
  expeditionDetails: {
    component: lazy(() => import("modals/ui/expeditions/expedition-details")),
    params: {} as IExpedition
  },
  expeditionFinished: {
    component: lazy(() => import("modals/ui/expeditions/expedition-finished")),
    params: {} as {
      currency: ExpeditionRewardsCurrency
      count: number
    }
  }
} as const
